
import BaseModel from './BaseModel';
import { getMomentDate } from '../utils/commonUtils';

export default class TourTicket extends BaseModel {
    constructor(data = {}) {
        super(data);
        this.setData(data)
    }

    setData(data = this.__data__) {
        this.id = data.id || undefined;
        this.ticketCode = data.ticketCode || undefined;
        this.isAvailable = data.isAvailable || undefined;
        this.propertyId = data.propertyId || undefined;
        this.propertyName = data.propertyName || undefined;
        this.name = data.name || this.translate.name || undefined;
        this.description = data.description || this.translate.description || undefined;
        this.shortDescription = data.shortDescription || this.translate.shortDescription || undefined;
        this.isDefault = data.isDefault || false;
    }

    export(hasTranslate = false) {
        const result = super.export({
            id: this.id,
            ticketCode: this.ticketCode,
            isAvailable: this.isAvailable,
            propertyId: this.propertyId,
            name: this.name,
            description: this.description,
            shortDescription: this.shortDescription,
            isDefault: this.isDefault
        });
        if (hasTranslate) result.translate = () => {
            return {
                id: this.translate.id,
                ticketId: this.translate.ticketId || this.id,
                name: this.name,
                description: this.description,
                shortDescription: this.shortDescription,
                languageCode: this.languageCode,
            }
        }
        return result;
    }
}